export default function(enable) {

    this._options.tweenPaths = enable;

    return this;
};
